import FieldRenderer from "./FieldRenderer";

export class FormArea extends FieldRenderer {
    constructor(props) {
        super(props);
    }

    backgroundColor(){
        if(this.props.HasBG){
            return 'bg__form--area';
        }
        return '';
    }

    areaFieldsClass(){
        if(this.props.HasPaddingBottom){
            return 'area__fields row pb-4 pb-md-5';
        }
        return 'area__fields row';
    }

    renderAreaHeader(){
        if(this.props.IconClass || this.props.Title || this.props.SubTitle){
            return (
                <div className="area__heading pt-3 pt-md-4 pt-lg-5 row">
                    <div className="col-12">
                        <i className={this.props.IconClass}/>
                        <h3>
                            {this.props.Title}
                        </h3>
                        <p>
                            {this.props.SubTitle}
                        </p>
                    </div>
                </div>
            )
        }
        return null;
    }

    render(){
        return (
            <div className={this.backgroundColor()}>
                <div className="my-3 my-md-4 my-lg-5 px-3">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            {this.renderAreaHeader()}
                            <div className={this.areaFieldsClass()}>
                                {this.renderFields()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default FormArea;
